/**
 * ChatChannelMemberGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { ChatChannelMemberData } from './chat_channel_member_data'

/**
 * ChatChannelMemberGetRes
 */
export interface ChatChannelMemberGetRes {
  /** 成员列表 */
  items?: ChatChannelMemberData[]
}

/**
 * ChatChannelMemberGetRes Schema
 */
export const ChatChannelMemberGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '成员列表',
      format: '[]*model.ChatChannelMemberData',
      items: { $ref: 'ChatChannelMemberData', description: '' },
      type: 'array',
      label: '成员列表',
    },
  },
  type: 'object',
}
